import { TemplateWidth } from '@/types/enums';

export interface EditorDevice {
  key: string;
  // i18n key (templateBuilder.toolbar.previewDevices.*), resolved with t() at display time
  labelKey: string;
  width: number;
}

// max-width of the dynamic_persistent_mobile sheet (helpers.ts)
export const MOBILE_STYLES_BREAKPOINT = 600;

// Narrowest frame the Outlook shapes are measured on: past the mobile and tablet breakpoints, and wide enough
// that a fluid section is never measured taller than a reading pane shows it
export const DESKTOP_LAYOUT_MIN_WIDTH = 1200;

// Narrowest frame on the desktop layout, which images are sized on: a wider one would size the images of a
// fluid section past the reading pane of a desktop client
export const DESKTOP_LAYOUT_NARROWEST_WIDTH = MOBILE_STYLES_BREAKPOINT + 1;

const PREVIEW_DEVICES_I18N = 'templateBuilder.toolbar.previewDevices';

export const EDITOR_MOBILE_DEVICES: EditorDevice[] = [
  { key: 'android-compact', labelKey: `${PREVIEW_DEVICES_I18N}.androidCompact`, width: 360 },
  { key: 'iphone', labelKey: `${PREVIEW_DEVICES_I18N}.iphone`, width: 393 },
  { key: 'android-large', labelKey: `${PREVIEW_DEVICES_I18N}.androidLarge`, width: 412 },
  { key: 'iphone-max', labelKey: `${PREVIEW_DEVICES_I18N}.iphoneMax`, width: 430 },
  { key: 'mobile-large', labelKey: `${PREVIEW_DEVICES_I18N}.mobileLarge`, width: parseInt(TemplateWidth.MOBILE, 10) },
];

export const DEFAULT_MOBILE_DEVICE: EditorDevice = EDITOR_MOBILE_DEVICES.find(
  (device) => `${device.width}px` === TemplateWidth.MOBILE,
) as EditorDevice;

export const isMobileViewportWidth = (width: string): boolean => {
  const pixels = /^\d+px$/.test(width) ? parseInt(width, 10) : NaN;
  return pixels <= MOBILE_STYLES_BREAKPOINT;
};
